export const ACCESSIBILITY_STORAGE_KEY = 'cs_wcagsidebar_settings';

export const DEFAULT_STATE = {
  panelOpen: false,
  expandedSections: ['text'],
  options: {},
};

export const DEFAULT_CONFIG = {
  sidebarSelector: '.js-a11y-sidebar',
  triggerSelector: '.js-a11y-trigger',
  panelSelector: '.js-a11y-panel',
  closeSelector: '.js-a11y-close',
  resetSelector: '.js-a11y-reset',
  accordionSelector: '.js-a11y-accordion',
  accordionHeaderSelector: '.js-a11y-accordion-header',
  optionBtnSelector: '.js-a11y-option',
  rulerSelector: '.js-a11y-ruler',
  openClass: 'is-open',
  expandedClass: 'is-expanded',
  activeClass: 'is-active',
};
